import { ThemeProvider } from '@change/ds-core-ui';

import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import { EducationModal } from './components/EducationModal';
import { EducationModalHeading } from './components/EducationModalHeading';

export type UseEducationModalProps = {
	isSunriseEnabled: boolean;
};

export const useEducationModal = createModalHook<UseEducationModalProps, { successfulShare: boolean }>({
	name: 'InstagramShareEducationModal',
	heading: function EducationModalHead() {
		return (
			<ThemeProvider>
				<EducationModalHeading />
			</ThemeProvider>
		);
	},
	body: function EducationModalBody({ closeModal }) {
		return (
			<ThemeProvider>
				<EducationModal
					onContinue={() => {
						closeModal({ successfulShare: true });
					}}
				/>
			</ThemeProvider>
		);
	},
	// oxlint-disable-next-line typescript/no-unsafe-assignment, typescript/no-unsafe-type-assertion
	stylesOverrides: {
		width: '100vw',
		position: 'fixed',
		bottom: 0,
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		'& [data-qa="modal-close-button"]': {
			width: 24,
			height: 24,
			top: 12,
			'& svg': {
				width: 24,
				height: 24,
			},
		},
		// oxlint-disable-next-line typescript/no-explicit-any
	} as any,
	// if share attempt is done within another modal, we need to kill that modal
	// to avoid multiple layers of modals
	killOpenModal: true,
});
